import { render, staticRenderFns } from "./shipmentdriver.vue?vue&type=template&id=42fa03aa&scoped=true"
import script from "./shipmentdriver.vue?vue&type=script&lang=js"
export * from "./shipmentdriver.vue?vue&type=script&lang=js"
import style0 from "./shipmentdriver.vue?vue&type=style&index=0&id=42fa03aa&prod&lang=scss&scoped=true"
import style1 from "./shipmentdriver.vue?vue&type=style&index=1&id=42fa03aa&prod&lang=scss"
import style2 from "./shipmentdriver.vue?vue&type=style&index=2&id=42fa03aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa03aa",
  null
  
)

export default component.exports